// extracted by mini-css-extract-plugin
export default {"container":"search_container__UANlq","search-icon":"search_search-icon__VCdb9","search-input":"search_search-input__wLJEU"};